// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useProfile } from "context/ProfileContext";

export default function ProtectedRoute({
  children,
  apps = [],
  requiredApp,
  requiredApps = [],
}) {
  const { profile } = useProfile();

  const isPlatformAdmin = !!profile?.is_admin;

  if (isPlatformAdmin) {
    return children;
  }

  const normalizedRequiredApps = [
    ...(requiredApp ? [requiredApp] : []),
    ...requiredApps,
  ];

  const isAllowed = normalizedRequiredApps.some((app) =>
    apps.includes(app)
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}